import { render, staticRenderFns } from "./ProgramAdd.vue?vue&type=template&id=2b2de256&"
import script from "./ProgramAdd.vue?vue&type=script&lang=js&"
export * from "./ProgramAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports